import { inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User, UserFormData } from '../types/user';
import { environment } from '../../environments/environment';
import { Observable, tap } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class UserServices {
  private readonly API_URL = environment.apiUrl;

  private http = inject(HttpClient);
  private toastr = inject(ToastrService);

  readonly users = signal<User[]>([]);
  readonly isLoading = signal<boolean>(false);

  loadUsers(): void {
    this.isLoading.set(true);
    this.http.get<User[]>(`${this.API_URL}/rest/user`).subscribe({
      next: (users) => {
        const sortedUsers = users.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
        this.users.set(sortedUsers);
        this.isLoading.set(false);
      },
      error: () => {
        this.isLoading.set(false);
        this.toastr.error('Felhasználók betöltése sikertelen');
      }
    });
  }

  addUser(user: UserFormData): Observable<User> {
    return this.http.post<User>(`${this.API_URL}/rest/auth/registration`, user).pipe(
      tap(() => this.loadUsers())
    );
  }

  updateUser(user: UserFormData): Observable<User> {
    return this.http.put<User>(`${this.API_URL}/rest/user/modify/${user.id}`, user).pipe(
      tap(() => this.loadUsers())
    );
  }

  deleteUser(userId: number): Observable<void> {
    return this.http.delete<void>(`${this.API_URL}/rest/user/delete/${userId}`).pipe(   // nincs még ilyen endpoint
      tap(() => this.loadUsers())
    );
  }

  findUserById(id: number): Observable<User> {
    return this.http.get<User>(`${this.API_URL}/rest/user/find-by/id/${id}`);
  }
}
